export const environment = {
  production: true,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  codigoSistema: '0001',
  timeToRefreshToken: 8000,

  jwt: {
    audience: 'DefaultAudience',
    issuer: 'DefaultIssuer'
  },

  /*WEB SERVICES*/
  api: {
    WS_IT: {
      url: 'https://agroextiende-erpcloud-qas-api.extech.pe/WS_IT/api', // QAS
      //url: 'http://localhost:51494/api', // LOCAL
      basicAuthorization: {
        username: 'HASSITApp',
        password: '975318642'
      }
    },
    WS_HCM: {
      url: 'https://agroextiende-erpcloud-qas-api.extech.pe/WS_HCM/api', // QAS
      //url: 'hhttp://localhost:59581/api', // LOCAL
      basicAuthorization: {
        username: 'HASSHCMApp',
        password: '975318642'
      }
    },
    WS_MM: {
      url: 'https://agroextiende-erpcloud-qas-api.extech.pe/WS_MM/api', // QAS
      //url: 'http://localhost:50594/api', // LOCAL
      basicAuthorization: {
        username: 'ProdMMApp',
        password: '975318642'
      }
    },
    WS_SD: {
      url: 'https://agroextiende-erpcloud-qas-api.extech.pe/WS_SD/api', // QAS
      // url: 'http://localhost:50673/api', // LOCAL
      basicAuthorization: {
        username: 'ProdSDApp',
        password: '975318642'
      }
    },
    WS_PP: {
      url: 'https://agroextiende-erpcloud-qas-api.extech.pe/WS_PP/api', // QAS
      //url: 'http://localhost:50663/api', // LOCAL
      basicAuthorization: {
        username: 'ProdPPApp',
        password: '975318642'
      }
    },
  },

  firebaseContratos: {
    apiKey: "AIzaSyB6ytvwZgItaT8K2rI6SamSKO1PozreI5M",
    authDomain: "erpcloudsoquimsa.firebaseapp.com",
    projectId: "erpcloudsoquimsa",
    storageBucket: "erpcloudsoquimsa.appspot.com",
    messagingSenderId: "168749378415",
    appId: "1:168749378415:web:188cf99c1d0d179e86569a",
    measurementId: "G-N72R60DKN4"
  },

  firebaseAlmacenes : {
    apiKey: "AIzaSyCVaZOvvr9aBEXTCgk2GXWUun2isG9RG1E",
    authDomain: "erpcloudalmacenes.firebaseapp.com",
    projectId: "erpcloudalmacenes",
    storageBucket: "erpcloudalmacenes.appspot.com",
    messagingSenderId: "116186437658",
    appId: "1:116186437658:web:05c95770438adfe13d99a3",
    measurementId: "G-5EXZ76J9P9"
  },

  EmailFirebase: "dev.soquimsa@gmail.com",
  PasswordFirebase: "T1C@2022.limagro",
};
